import { store } from "../../redux/store"

const areCallsInProgress = (callsToCheck, callsInProgress = undefined) => {
  const calls = callsInProgress || store.getState().api.callsInProgress
  return !!calls.filter(cip => callsToCheck.indexOf(cip) !== -1).length
}

export default { areCallsInProgress }
